import React from "react";
import Behind from "./Behind";
import HireAs from "./HireAs";

const AboutMe = () => {
  return (
    <div className="mx-auto sm:max-w-xl md:max-w-full lg:max-w-screen-xl md:px-24 lg:px-8 ">
      <div className="font-serif items-center text-center mt-8 mb-5">
        <h1 className="text-3xl font-bold  text-black">About Me</h1>
        <p className="text-xl">
          Morbi leo risus, porta ac consectetur ac, vestibulum at eros. Etiam
          porta sem <br /> malesuada magna mollis euismod. Maecenas sed diam
          eget risus varius blandit sit.
        </p>
      </div>

      <Behind />
      <HireAs />
    </div>
  );
};

export default AboutMe;
